import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styles from './style.module.scss';

export interface ChipProps {
    text: string;
    value: string;
    Icon?: IconProp;
    backgroundColor: string;
    borderColor?: string;
}

export interface ChipSettings {
    width: number;
}

export const RAGPillColours = {
    ragRed: styles['rag-colour-red'],
    ragRedBorder: styles['rag-colour-red-border'],
    ragAmber: styles['rag-colour-amber'],
    ragAmberBorder: styles['rag-colour-amber-border'],
    ragGreen: styles['rag-colour-green'],
    ragGreenBorder: styles['rag-colour-green-border'],
    ragGrey: styles['rag-colour-grey'],
    ragGreyBorder: styles['rag-colour-grey-border'],
    ragPurple: styles['rag-colour-purple'],
    ragPurpleBorder: styles['rag-colour-purple-border'],
    ragNone: '#FFF',
    ragNoneBorder: '#B8B8B8',
};

export enum RAGColour {
    None = 0,
    Red = 1,
    Amber = 2,
    Green = 3,
    Purple = 4,
    Grey = 5,
}

export const RAGColourMap: Map<RAGColour, { color: string; borderColor: string }> = new Map([
    [RAGColour.Red, { color: RAGPillColours.ragRed, borderColor: RAGPillColours.ragRedBorder }],
    [RAGColour.Amber, { color: RAGPillColours.ragAmber, borderColor: RAGPillColours.ragAmberBorder }],
    [RAGColour.Green, { color: RAGPillColours.ragGreen, borderColor: RAGPillColours.ragGreenBorder }],
    [RAGColour.Purple, { color: RAGPillColours.ragPurple, borderColor: RAGPillColours.ragPurpleBorder }],
    [RAGColour.Grey, { color: RAGPillColours.ragGrey, borderColor: RAGPillColours.ragGreyBorder }],
]);

export const statusChips: ChipProps[] = [
    {
        text: 'Queued',
        value: 'queued',
        Icon: ['far', 'clock'],
        backgroundColor: '#edcda4',
    },
    {
        text: 'Ready',
        value: 'ready',
        Icon: ['far', 'circle-check'],
        backgroundColor: '#bdd9ba',
    },
    {
        text: 'Failed',
        value: 'failed',
        Icon: ['far', 'circle-xmark'],
        backgroundColor: '#de8c8b',
    },
    {
        text: 'Obsolete',
        value: 'obsolete',
        Icon: ['far', 'trash-can'],
        backgroundColor: '#c0c0c0',
    },
];
